angular.module('shared-calendar')
    .component('sharedCalendar', {
        templateUrl: 'app/task/shared-calendar/shared-calendar.html',
        controller: function ($q, $scope, toastr, TaskService, DocumentType, TaskStatus, TaskCalendarV4Service, SharedCalendarCookieFilterService, SharedCalendar, Principal) {
            this.$onInit = () => {
                DocumentType.query({doc: "task"}).$promise.then(items => this.documentTypes = items);
                TaskStatus.list().$promise.then(items => this.statuses = items);

                this.documentFilterService = SharedCalendarCookieFilterService;
                this.filters = SharedCalendarCookieFilterService.filters;
                this.canAccessNotes = Principal.hasAnyAuthority(['ROLE_NOTES']);
                let calendarConfig = TaskCalendarV4Service.defaultConfig();
                calendarConfig.defaultView = 'dayGridMonth';
                this.taskCalendarConfig = calendarConfig;
                this.initUserFilter();
            }

            this.toggleUserSelection = user => {
                let idx = this.filters.users.indexOf(user.id);
                if (idx > -1) {
                    this.filters.users.splice(idx, 1);
                }
                else {
                    this.filters.users.push(user.id);
                }
                this.search();
            };
            this.selectAll = () => {
                let users = angular.copy(this.users);
                users.push(this.loggedInUser);
                angular.forEach(users, user => {
                    let idx = this.filters.users.indexOf(user.id);
                    if (idx < 0) {
                        this.filters.users.push(user.id);
                    }
                });
                this.search();
            };
            this.deselectAll = () => {
                this.filters.users = [];
                this.search();
            };

            this.toggleWorkerFilter = name => {
                this.documentFilterService.toggle(name);
                this.search();
            }

            this.search = () => {
                this.documentFilterService.save();
                this.calendar.refetchEvents();
            }

            this.initUserFilter = () => {
                let $currentUserPromise = Principal.currentUser().then(user => {
                    this.loggedInUser = user;
                    if (angular.isUndefined(this.filters.users)) {
                        this.filters.users = [];
                        this.toggleUserSelection(user);
                    }
                });

                let $sharedCalendarUsersPromise = SharedCalendar.users().$promise.then(result => this.users = result);
                this.usersLoadedPromise = $q.all([$currentUserPromise, $sharedCalendarUsersPromise])
                    .then(() => {
                        let sharedUsersId = this.users.map(user => user.id);
                        let filterUserId = angular.copy(this.filters.users);
                        filterUserId.forEach(userId => {
                            let idx = sharedUsersId.indexOf(userId);
                            if (idx < 0 && this.loggedInUser.id !== userId) {
                                this.filters.users.splice(this.filters.users.indexOf(userId), 1);
                            }
                        });
                    })
            }
            this.onCalendarInit = calendar => {
                this.calendar = calendar;
                this.usersLoadedPromise.then(() => {
                    let taskEventSource = {
                        url: '/crm/api/shared-calendar/tasks',
                        extraParams: this.getExtraParams
                    };
                    let noteEventSource = {
                        url: '/crm/api/note/find',
                        extraParams: this.getExtraParams
                    };
                    let leaveEventSource = {
                        url: '/crm/api/leave/calendar',
                        extraParams: this.getExtraParams
                    };
                    this.calendar.addEventSource(taskEventSource);
                    if (this.canAccessNotes) this.calendar.addEventSource(noteEventSource);
                    this.calendar.addEventSource(leaveEventSource);
                });
            }

            this.getExtraParams = () => {
                return Object.entries(this.filters)
                    .filter(([_, v]) => v != null)
                    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
            }

            $scope.$on('task.updated', () => this.calendar.refetchEvents());
            $scope.$on('task.deleted', () => this.calendar.refetchEvents());
        }
    })
